import React from 'react'

function HtmlIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xlink="http://www.w3.org/1999/xlink" svgjs="http://svgjs.com/svgjs" width="30" height="30" x="0" y="0" viewBox="0 0 434.147 434.147" ><g><path d="m27.336 14.372 28.177 360.474a13.333 13.333 0 0 0 9.263 11.67l148.268 47.008c2.622.831 5.437.831 8.059 0l148.268-47.008a13.333 13.333 0 0 0 9.263-11.67l28.177-360.474C407.417 6.622 401.292 0 393.519 0H40.629c-7.773 0-13.898 6.622-13.293 14.372zm307.217 111.843H150.918l5.542 51.105h174.099L319.17 323.013l-102.096 32.369-102.096-32.369-5.95-76.116h53.588v37.336l55.89 15 55.556-15 4.31-59.503H107.295L95.937 79.419H338.21l-3.657 46.796z"  fill="#fc490b" data-original="#fc490b"></path></g></svg>
  )
}

export default HtmlIcon